import { clearDomainData, showCookieList } from './../../../store/modules/consentManagement'
import { componentDidMount, componentWillUnmount } from '../../../components/Lifecycles'
import { compose, pipe } from 'ramda'
import CookieList from './CookieList'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  locale: state.router.locale,
  otData: state.consentManagement.otData,
})

const mapDispatchToProps = dispatch => ({
  showCookieList: compose(dispatch, showCookieList),
  clearDomainData: compose(dispatch, clearDomainData),
})

// didMount :: Props -> Action
const didMount = ({ showCookieList }) => showCookieList()

// willUnmount :: Props -> Action
const willUnmount = ({ clearDomainData }) => clearDomainData()

// lifecycles :: React.Component -> React.Component
const lifecycles = pipe(
  componentWillUnmount(willUnmount),
  componentDidMount(didMount, true),
)(CookieList)

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(lifecycles)
